export const urlApi = "https://apilegajosmrw.rawson.gov.ar";
//export const urlApi = "http://localhost:3010";

